import React from "react";
import { RequireRole } from "../../app/router/RequireRole";
import { PlanPage } from "./pages/PlanPage";

/**
 * Plan feature routes — TASK-18 (R6: owned exclusively by src/features/plan/).
 *
 * Protected (RequireRole OWNER):
 *   /:slug/app/plan   →  PlanPage (plan actual, límites, bloques, facturas, upgrade)
 *
 * Register in AppRouter.js:
 *   import planRoutes from '../../features/plan/routes';
 *   registry.register(planRoutes);
 */
const planRoutes = [
  {
    path: "/:slug/app/plan",
    element: <RequireRole roles={["OWNER"]} />,
    children: [{ index: true, element: <PlanPage /> }],
  },
];

export default planRoutes;
